/* eslint-disable */
import React from 'react'
import { connect } from 'react-redux'
import { object, func } from 'prop-types'
import styles from './StravaListData.styl'
import { InfoWarning } from '../Messages'
import { putRequest } from '../../helpers/requestActions'
import InputListItem from '../StravaInputType/StravaInputType'
import { calculateEquivalentDistance, calculateCalories } from '../../helpers/helpers'

const compTranslate = {
	Flexibility: 'Flexibilidade',
	Weight: 'Musculação'
}

export default class StravaListData extends React.Component {
	static propTypes = {
		workout: object,
		updateWorkout: func,
		close: func
	}
	constructor(props) {
		super(props)
		const { athleteParams } = props.workout
		const defaultState = {
			time: '',
			distance: '',
			averageBPM: '',
			maxBPM: '',
			DA: '',
			DP: '',
			DN: '',
			calories: '',
			effort: '',
			motivation: ''
		}
		if (athleteParams) {
			for (const key in defaultState) {
				defaultState[key] = athleteParams[key] || ''
			}
		}
		this.state = {
			data: {
				...defaultState,
				textarea: ''
			},
			warnForm: [false, '']
		}
	}
	componentWillReceiveProps(nextProps) {
		const { data } = nextProps
		this.setState(prevState => {
			if (!data) { return prevState }
			return {
				data: {
					...prevState.data,
					...data
				}
			}
		})
	}
	handleChange = (e) => {
		const { name, value } = e.target
		this.setState(prevState => ({
			data: {
				...prevState.data,
				[name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)
			}
		}))
	}
	handleTextAreaChange = (e) => {
		const { name, value } = e.target
		this.setState(prevState => ({
			data: {
				...prevState.data,
				[name]: value
			}
		}))
	}
	handleSubmit = (e) => {
		e.preventDefault()
		const { data } = this.state
		const { workout, dispatch, close, updateWorkout } = this.props
		const { distance, time } = data
		const { id } = workout
		const state = { ...data }

		if (isNaN(parseInt(state.averageBPM, 10))) {
			this.setState({ warnForm: [true, 'Inserir frequência média!'] })
			return
		}
		if (isNaN(parseInt(state.effort, 10))) {
			this.setState({ warnForm: [true, 'Inserir esforço!'] })
			return
		}
		if (isNaN(parseInt(state.motivation, 10))) {
			this.setState({ warnForm: [true, 'Inserir motivação!'] })
			return
		}

		const velocidadeUnidadeTreino = distance / (time / 60)
		state.velocity = Math.floor(velocidadeUnidadeTreino * 100) / 100
		putRequest('/api/workouts/strava/upload', { state, workout })
			.then(response => {
				// TODO: Bad Reponse Handle
				updateWorkout(response)
			})
			.catch(err => {
				console.log(err)
			})
		close()
	}
	handleDistanceChange(e) {
		const { name, value } = e.target
		const { athlete, workout } = this.props
		const parsedValue = parseFloat(value)
		this.setState(prevState => {
			const { data: { DP, DN } } = prevState
			const equivalentDistance = calculateEquivalentDistance(parsedValue || 0, DP, DN)
			const calories = calculateCalories(equivalentDistance, athlete, workout.goal)
			return {
				data: {
					...prevState.data,
					[name]: !isNaN(parsedValue) ? Math.round(parsedValue * 100) / 100 : '',
					calories
				}
			}
		})
	}
	handleDnAndDpChange(e) {
		const { name, value } = e.target
		const { athlete, workout } = this.props
		const calculatedValue = isNaN(parseInt(value, 10)) ? '' : parseInt(value, 10)

		this.setState(prevState => {
			const { data } = prevState
			const newSlope = { DP: data.DP || 0, DN: data.DN || 0 }
			newSlope[name] = calculatedValue || 0
			const DA = newSlope.DP + newSlope.DN
			const equivalentDistance = calculateEquivalentDistance(data.distance, newSlope.DP, newSlope.DN)
			const calories = calculateCalories(equivalentDistance, athlete, workout.goal)
			return {
				data: {
					...data,
					[name]: calculatedValue,
					DA,
					calories
				}
			}
		})
	}

	handleRadioChange(value, e) {
		const event = { name: e.target.name, value }
		this.setState((prevState) => ({ data: { ...prevState.data, [event.name]: value } }))
	}
	render() {
		const { data, warnForm } = this.state
		const { workout } = this.props
		const complementaryWorkouts = [workout.flexWorkout, workout.weightWorkout].filter(r => r).map((ele, index) => (
			<div key={ index } className={ styles.complementary }>
				<p>{ compTranslate[ele.type] }</p>
				<ul>
					<li><input type="radio" name={ `${ ele.type.toLowerCase() }Value` } value={ true } onChange={ this.handleRadioChange.bind(this, true) } />Fiz o treino</li>
					<li><input type="radio" name={ `${ ele.type.toLowerCase() }Value` } value={ false } onChange={ this.handleRadioChange.bind(this, false) } />Não fiz o treino</li>
				</ul>
			</div>
		))

		return (
			<form onSubmit={ this.handleSubmit } className={ styles['form'] }>
				{ warnForm[0] ? <InfoWarning info={ warnForm[1] } close={ () => { this.setState({ warnForm: [false, ''] }) } } /> : null }
				<div className={ styles.params }>
					<div className={ styles.title }>
						<h2 className={ styles.darker }>Objetivos</h2>
						<h2 className={ styles.lighter }>Dados do teu treino</h2>
					</div>
					<div className={ styles.lists }>
						<ul >
							<InputListItem
								required
								leftTitle="Tempo"
								rightTitle="Tempo"
								leftValue={ `${ workout.currentParams.time } m` }
								rightValue={ data.time }
								inputName="time"
								handleChange={ this.handleChange }
							/>
							<InputListItem
								required
								leftTitle="Distância"
								rightTitle="Distância"
								leftValue={ `${ workout.currentParams.distance } km` }
								rightValue={ data.distance }
								inputName="distance"
								handleChange={ this.handleDistanceChange.bind(this) }
							/>
							<InputListItem
								required
								leftTitle="FC média"
								rightTitle="FC média"
								leftValue={ `${ workout.currentParams.averageBPM } ppm` }
								rightValue={ data.averageBPM }
								inputName="averageBPM"
								handleChange={ this.handleChange }
							/>
							<InputListItem
								required
								leftTitle="FC máxima"
								rightTitle="FC máxima"
								leftValue={ `${ workout.currentParams.maxBPM } ppm` }
								rightValue={ data.maxBPM }
								inputName="maxBPM"
								handleChange={ this.handleChange }
							/>
							<InputListItem
								required
								leftTitle="Desnível Positivo"
								rightTitle="Desnível Positivo (D+)m"
								leftValue=""
								rightValue={ data.DP }
								inputName="DP"
								handleChange={ this.handleDnAndDpChange.bind(this) }
							/>
							<InputListItem
								required
								leftTitle="Desnível Negativo"
								rightTitle="Desnível Negativo (D-)m"
								leftValue=""
								rightValue={ data.DN }
								inputName="DN"
								handleChange={ this.handleDnAndDpChange.bind(this) }
							/>
							<InputListItem
								required
								leftTitle="Desnível Acumulado"
								rightTitle="Desnível Acumulado (DA)m"
								leftValue=""
								rightValue={ data.DA }
								inputName="DA"
								handleChange={ this.handleChange }
							/>
							<InputListItem
								required
								leftTitle="Calorias"
								rightTitle="Calorias"
								leftValue={ `${ workout.currentParams.calories }` }
								rightValue={ data.calories }
								inputName="calories"
								handleChange={ this.handleChange }
							/>
						</ul>
					</div>
					<div className={ styles.textarea }>
						<p>Observacoes</p>
						<textarea name="observations" name="textarea" value={ data.textarea } onChange={ this.handleTextAreaChange } />
					</div>
					{ complementaryWorkouts }
					<div className={ styles.effort }>
						<div className={ styles.box }>
							<h4>Esforço</h4>
							<div>
								<p>Avalia o teu esforço de 1 a 10</p>
								<input type="number" placeholder="" min="0" max="10" name="effort" value={ data.effort } onChange={ this.handleChange } required />
							</div>

						</div>
						<div className={ styles.box }>
							<h4>Motivação</h4>
							<div>
								<p>Avalia a tua motivação de 1 a 10</p>
								<input type="number" placeholder="" min="0" max="10" name="motivation" value={ data.motivation } onChange={ this.handleChange } required />
							</div>
						</div>

					</div>
				</div>
				<input className={ styles.save } type="submit" value="Guardar Treino" />
			</form>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/StravaListData/StravaListData.js